import { render, staticRenderFns } from "./modalVacunas.vue?vue&type=template&id=ce4e8730&"
import script from "./modalVacunas.vue?vue&type=script&lang=js&"
export * from "./modalVacunas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports